import {
  ModelInput,
} from '@equifinance/shared';
import {
  Label, SelectWrapper, UnderwriterDecisionContainer, UnderwriterDecisionTitle,
} from '../../../../components/UnderwriterDecision';

export default function SendOfferUnderwriterDecision() {
  return (
    <UnderwriterDecisionContainer>
      <UnderwriterDecisionTitle>
        <Label>{'Underwriter\'s decision'}</Label>
        <SelectWrapper>
          <ModelInput
            field="sendOffer.decision"
            disabled
          />
        </SelectWrapper>
      </UnderwriterDecisionTitle>
    </UnderwriterDecisionContainer>
  );
}
